import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

const ACTIVE_CLASS = 'active'

const initBlockTabsPin = () => {
    const sections = document.querySelectorAll('[data-tabs-pin]')
    if (!sections.length) return

    const mm = gsap.matchMedia()

    mm.add('(min-width: 1024px)', () => {
        const cleanups = []

        sections.forEach((section) => {
            const viewport = section.querySelector('[data-tabs-pin-viewport]')
            const track = section.querySelector('[data-tabs-pin-track]')
            const items = Array.from(
                section.querySelectorAll('[data-tabs-pin-item]')
            )
            const buttons = Array.from(
                section.querySelectorAll('[data-tabs-pin-button]')
            )

            if (!viewport || !track || !items.length) return

            const distance = () =>
                Math.max(track.scrollHeight - viewport.clientHeight, 0)

            const itemCenter = (item) =>
                item.offsetTop + item.offsetHeight / 2

            const activeIndexForOffset = (y) => {
                if (y <= 0) return 0
                if (y >= distance()) return items.length - 1

                const target = y + viewport.clientHeight / 2
                let activeIndex = 0
                let closestDistance = Infinity

                items.forEach((item, i) => {
                    const itemDistance = Math.abs(itemCenter(item) - target)

                    if (itemDistance < closestDistance) {
                        closestDistance = itemDistance
                        activeIndex = i
                    }
                })

                return activeIndex
            }

            const setActive = (index) => {
                buttons.forEach((button, i) => {
                    button.classList.toggle(ACTIVE_CLASS, i === index)
                    button.setAttribute('aria-current', String(i === index))
                })
            }

            const tween = gsap.to(track, {
                y: () => -distance(),
                ease: 'none',
                scrollTrigger: {
                    trigger: section,
                    start: 'top top',
                    end: () => `+=${distance()}`,
                    pin: true,
                    scrub: true,
                    invalidateOnRefresh: true,
                    onUpdate: (self) => {
                        const y = distance() * self.progress
                        setActive(activeIndexForOffset(y))
                    }
                }
            })

            buttons.forEach((button, index) => {
                button.addEventListener('click', () => {
                    const item = items[index]
                    const scrollTrigger = tween.scrollTrigger
                    const targetY = Math.min(
                        Math.max(
                            itemCenter(item) - viewport.clientHeight / 2,
                            0
                        ),
                        distance()
                    )

                    window.lenis?.scrollTo(scrollTrigger.start + targetY)
                })
            })

            setActive(activeIndexForOffset(0))

            cleanups.push(() => {
                tween.scrollTrigger?.kill()
                tween.kill()
            })
        })

        return () => cleanups.forEach((cleanup) => cleanup())
    })
}

document.addEventListener('DOMContentLoaded', () => {
    initBlockTabsPin()
})

export { initBlockTabsPin }
